<template>
  <div class='table-box'>
    <globalTag>
      <el-form label-width='90px'>
        <el-row>
          <el-col :span='10'>
            <el-form-item label='日期：'>
              <div style='display: flex'>
                <el-date-picker
                  v-model='queryForm.startTimeStr'
                  type='datetime'
                  format='yyyy-MM-dd HH:mm:ss'
                  value-format='yyyy-MM-dd HH:mm:ss'
                  placeholder='开始时间'
                >
                </el-date-picker>
                <div style='margin: 0 15px'>至</div>
                <el-date-picker
                  v-model='queryForm.endTimeStr'
                  type='datetime'
                  format='yyyy-MM-dd HH:mm:ss'
                  value-format='yyyy-MM-dd HH:mm:ss'
                  placeholder='结束时间'
                >
                </el-date-picker>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span='5' :offset='2'>
            <el-button
              type='primary'
              class='searchBtns'
              @click='getTableData'
            >查询
            </el-button>
          </el-col>
        </el-row>
      </el-form>
    </globalTag>
    <div>
      <el-table
        :data='tableData'
        border
        style='width: 100%'
        :header-cell-style="{ background: '#f2f2f2', color: '#000' }"
      >
        <el-table-column
          type='index'
          align='center'
          label='序号'
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop='loginName'
          align='center'
          show-overflow-tooltip
          label='登录名'
        >
        </el-table-column>
        <el-table-column
          prop='callTimes'
          align='center'
          show-overflow-tooltip
          label='呼入次数'
        >
        </el-table-column>
        <el-table-column
          prop='connectCount'
          align='center'
          show-overflow-tooltip
          label='接听次数'
        >
        </el-table-column>
        <el-table-column
          prop='noConnectCount'
          show-overflow-tooltip
          align='center'
          label='未接听次数'
        >
        </el-table-column>
        <el-table-column
          prop='connectionRate'
          show-overflow-tooltip
          align='center'
          label='接通率'
        >
        </el-table-column>
        <el-table-column
          prop='countless30'
          show-overflow-tooltip
          align='center'
          label='<30秒'
        >
        </el-table-column>
        <el-table-column
          prop='countless60'
          show-overflow-tooltip
          align='center'
          label='30-60秒'
        >
        </el-table-column>
        <el-table-column
          prop='countless180'
          show-overflow-tooltip
          align='center'
          label='60-180秒'
        >
        </el-table-column>
        <el-table-column
          prop='countbig180'
          show-overflow-tooltip
          align='center'
          label='>180秒'
        >
        </el-table-column>
        <el-table-column
          prop='connectTimeLenTotal'
          show-overflow-tooltip
          align='center'
          width='140px'
          label='总时长'
        >
        </el-table-column>
        <!--        <el-table-column label="操作" align="center" width="250">-->
        <!--          <template slot-scope="scope">-->
        <!--            <div class="operation-btn">-->
        <!--              <div class="operation-color">查看</div>-->
        <!--              <div class="operation-color">编辑</div>-->
        <!--              <div class="operation-color">删除</div>-->
        <!--            </div>-->
        <!--          </template>-->
        <!--        </el-table-column>-->
      </el-table>

      <el-pagination
        background
        @size-change='handleSizeChange'
        @current-change='handleCurrentChange'
        :current-page='pageConfig.pageNo'
        :page-sizes='[5, 10, 20, 50]'
        :page-size='pageConfig.pageSize'
        layout='total, sizes, prev, pager, next, jumper'
        :total='pageConfig.total'
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import request from '@/utils/request.js'
import headLine from '../components/headline'

export default {
  components: {
    headLine
  },
  data() {
    return {
      queryForm: {},
      startTimeStr: '',
      endTime: '',
      tableData: [],
      pageConfig: {
        pageNo: 1,
        pageSize: 10,
        total: 0
      },
      isSearchContent: true
    }
  },
  created() {
    this.getTableData()
  },
  methods: {
    Reset() {
      this.queryForm = {}
      this.getTableData()
    },
    // 每页显示条数切换
    handleSizeChange(val) {
      this.pageConfig.pageSize = val
      this.getTableData()
    },
    // 页码切换
    handleCurrentChange(val) {
      this.pageConfig.pageNo = val
      this.getTableData()
    },
    getTableData() {
      request({
        url: '/jjyl/traffic/callInfo/info/callStatistics',
        method: 'POST',
        data: {
          pageNo: this.pageConfig.pageNo,
          pageSize: this.pageConfig.pageSize,
          ...this.queryForm,
          // startTimeStr: this.startTime,
          // endTimeStr: this.endTime,
          outCall: 0
        }
      }).then((res) => {
        if (res.code === 200 && res.content) {
          if (res.content != null) {
            this.tableData = res.content.list
            this.tableData.forEach((item) => {
              item.connectionRate =
                (item.connectionRate * 100).toFixed(2) + '%'
              if (item.connectionRate == '100.00%') {
                item.connectionRate = 100 + '%'
              }
            })
          } else {
            this.tableData = []
          }
        }
      })
    }
  }
}
</script>

<style lang='less' scoped>
.operation-btn {
  width: 100%;
  display: flex;
  cursor: pointer;
  justify-content: space-between;
}

.elder_manage_title {
  position: relative;
  width: 100%;
  margin-bottom: 15px;

  &::after {
    position: absolute;
    left: 120px;
    right: 0;
    display: block;
    content: "";
    border-bottom: 1px solid #e4e7ed;
  }

  .title {
    box-sizing: border-box;
    display: inline-block;
    width: 120px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    color: #409eff;
    font-size: 14px;
    border: 1px solid #e4e7ed;
    border-bottom: none;
    border-radius: 4px 4px 0 0;
    box-sizing: border-box;
    background: #ffffff;
  }
}

.searchDomw {
  cursor: pointer;
}
</style>
